export default __webpack_public_path__ + "static/media/logo.986dc421.jpg";